"use strict";

function getNearestValue(needle) {
  var haystack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _ref = arguments.length > 2 ? arguments[2] : undefined,
      _ref$accessor = _ref.accessor,
      accessor = _ref$accessor === void 0 ? function (v) {
    return v;
  } : _ref$accessor,
      _ref$preSorted = _ref.preSorted,
      preSorted = _ref$preSorted === void 0 ? true : _ref$preSorted;

  var targetValue = accessor(needle);
  var prevDiff = Infinity;

  if (!haystack.length) {
    return null;
  }

  if (!preSorted) {
    hayStack.sort(function (a, b) {
      return accessor(a) - accessor(b);
    });
  }

  for (var i = haystack.length - 1; i >= 0; i--) {
    var diff = Math.abs(accessor(haystack[i]) - targetValue);

    if (diff >= prevDiff) {
      return haystack[i + 1];
    }

    prevDiff = diff;

    if (i === 0) {
      return haystack[0];
    }
  }
}

function rootMeanSquare(values) {
  return Math.sqrt(values.reduce(function (acc, v) {
    acc += Math.pow(v, 2);
    return acc;
  }, 0) / values.length);
}

module.exports = {
  getNearestValue: getNearestValue,
  rootMeanSquare: rootMeanSquare
};